<template>
  <ul class="linkbox">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'LinkBox'
}
</script>

<style scoped>

</style>